import './BossWarning.css';

function BossWarning({ visible }) {
  if (!visible) {
    return null;
  }

  return (
    <div className="boss-warning" aria-hidden="true">
      Boss Incoming
    </div>
  );
}

export default BossWarning;
